import request from '@/utils/request'


// 查询仓库主列表
export function listWarehouse(query) {
  return request({
    url: '/warehouse/warehouse/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询仓库主分页
export function pageWarehouse(query) {
  return request({
    url: '/warehouse/warehouse/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询仓库主详细
export function getWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/detail',
    method: 'get',
    params: data
  })
}

// 新增仓库主
export function addWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/add',
    method: 'post',
    data: data
  })
}

// 修改仓库主
export function updateWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/edit',
    method: 'post',
    data: data
  })
}

// 删除仓库主
export function delWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/delete',
    method: 'post',
    data: data
  })
}
